import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import KKokkioWorldIcon from '../component/KKokkioWorldIcon';
import { ReactComponent as LeftArrow } from "../assets/svg/icon-arrow-left-small-mono.svg";
import { ReactComponent as LeftArrowWhite } from "../assets/svg/icon-arrow-left-small-white.svg";

export default function Header({ Text, Link, Icon, Text2, color, back_disable, back_work }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBackClick = () => {
    // back_work가 'no'인 경우 함수 실행하지 않음
    if (back_work === 'no') {
      return;
    }

    // Link 변수가 존재하면 해당 경로로 이동
    if (Link) {
      navigate(Link);
    } else {
      const currentPath = location.pathname;

      // Legacy로 이동: Onboarding은 V4로 대체됨
      // V4 경로 체크로 변경
      if (
        currentPath === '/V4/PhoneNumber' ||
        currentPath === '/V4/Password' ||
        currentPath === '/V4/UnderAge'
      ) {
        // 뒤로 가기 불가능 알림 등의 작업 수행
      } else {
        // Link 변수가 없고 이전 페이지가 특정 경로에 해당하지 않는 경우 이전 페이지로 이동
        window.history.back();
      }
    }
  };

  return (
    <>
      <div className='header'>
        <div className="top_bar" style={{ marginLeft: '20px', visibility: back_disable ? 'hidden' : 'visible' }}>
          {!back_disable && (
            <a onClick={handleBackClick}>
              {color === 'white' ? <LeftArrowWhite /> : <LeftArrow />}
            </a>
          )}
        </div>
        {Icon === 'yes' && (
          <div className="kkokkio-world-icon">
            <KKokkioWorldIcon />
          </div>
        )}
      </div>

      <br />

      {/* Text 값이 비어있지 않은 경우에만 렌더링 */}
      {Text && (
        <>
          <div style={{ display: 'flex', textAlign: 'left' }}>
            <div style={{ marginTop: '40px', marginLeft: '25px', display: 'flex', flexDirection: 'column' }}>
              <h2 className='title' initial="hidden" animate="visible">{Text}</h2>
              <h2 className='title' initial="hidden" animate="visible">{Text2}</h2>
            </div>
          </div>
        </>
      )}
    </>
  );
}
